import { getAttributeKeys } from '../index';
import { isUnlimited } from '../../../packagesUtils';
import { Attributes } from '../../attributes';

export const getLabel = (i18n, name, subCategoryId) => {
    const attributeKeys = getAttributeKeys(name, subCategoryId, [Attributes.label]);

    return i18n.t(attributeKeys);
};

export const getFormattedLabel = (i18n, name, type, value, subCategoryId) => {
    const attributeKeys = getAttributeKeys(name, subCategoryId, [
        Attributes.title, Attributes.buyerTitle, Attributes.label
    ]);

    return i18n.t(attributeKeys, {
        count: calculateCount(i18n, value)
    });
};

const calculateCount = (i18n, value) => isUnlimited(value)
    ? i18n.t('gig_page_perseus.packages.unlimited')
    : value;
